/* eslint-disable promise/always-return, promise/catch-or-return */
// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production,
// and gives it offline capabilities. However, it also means that
// developers (and users) will only see deployed updates on subsequent
// visits to a page, after all the existing tabs open on the page have
// been closed, since previously cached resources are updated in the
// background.

// To learn more about the benefits of this model and instructions on
// how to opt-in, read http://bit.ly/CRA-PWA

// eslint-disable-next-line no-process-env
const { NODE_ENV } = process.env;
const SW_URL = `${window.location.origin}/service-worker.js`;

function isLocalhost( name = window.location.hostname ) {
  return name === 'localhost' || name === '[::1]' ||
    name.match( /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/u );
}
function isSupported() {
  return NODE_ENV === 'production' && 'serviceWorker' in navigator;
}
/*
function isCorrectOrigin() {
  const publicUrl = new URL( PUBLIC_URL, window.location.href );
  // Our service worker won't work if PUBLIC_URL is on a different
  // origin from what our page is served on. This might happen if
  // a CDN is used to serve assets; see
  // https://github.com/facebook/create-react-app/issues/2374
  return publicUrl.origin === window.location.origin;
}
*/

export function register( config ) {
  // if ( ! isSupported() || ! isCorrectOrigin() ) return;
  if ( ! isSupported() ) return;

  window.addEventListener( 'load', () => {
    if ( isLocalhost() ) {
      // This is running on localhost. Let's check if a service
      // worker still exists or not.
      checkValidServiceWorker( config );
    } else {
      // Is not localhost. Just register service worker
      registerValidSW( config );
    }
  } );
}

function registerValidSW( config ) {
  navigator.serviceWorker.register( SW_URL ).then( registration => {
    registration.onupdatefound = () => {
      const installingWorker = registration.installing;
      if ( ! installingWorker ) return;
      installingWorker.onstatechange = () => {
        if ( installingWorker.state === 'installed' ) {
          if ( navigator.serviceWorker.controller ) {
            // At this point, the updated precached content has been
            // fetched, but the previous service worker will still
            // serve the older content until all client tabs are
            // closed.
            // eslint-disable-next-line no-console
            console.log(
              'New content is available and will be used when all',
              'tabs for this page are closed.',
            );

            // Execute callback
            if ( config && config.onUpdate ) config.onUpdate( registration );
          } else {
            // At this point, everything has been precached.  It's the
            // perfect time to display a "Content is cached for
            // offline use." message.
            // eslint-disable-next-line no-console
            console.log( 'Content is cached for offline use.' );

            // Execute callback
            if ( config && config.onSuccess ) config.onSuccess( registration );
          }
        }
      };
    };
  } ).catch( error => {
    // eslint-disable-next-line no-console
    console.error( 'Error during service worker registration:', error );
  } );
}

function checkValidServiceWorker( config ) {
  // Check if the service worker can be found. If it can't reload the
  // page.
  fetch( SW_URL ).then( response => {
    // Ensure service worker exists, and that we really are getting
    // a JS file.
    const contentType = response.headers.get( 'content-type' );
    if (
      response.status === 404 ||
      ( contentType && contentType.indexOf( 'javascript' ) === -1 )
    ) {
      // No service worker found. Probably a different app. Reload the
      // page.
      navigator.serviceWorker.ready.then( registration => {
        registration.unregister().then( () => window.location.reload() );
      } );
    } else {
      // Service worker found. Proceed as normal.
      registerValidSW( SW_URL, config );
    }
  } ).catch( () => {
    // eslint-disable-next-line no-console
    console.log( 'No internet connection. Running in offline mode.' );
  } );
}

export function unregister() {
  if ( 'serviceWorker' in navigator ) {
    navigator.serviceWorker.ready.then( reg => reg.unregister() );
  }
}
